import { render, staticRenderFns } from "./SalesCountReport.vue?vue&type=template&id=6a78151a&"
import script from "./SalesCountReport.vue?vue&type=script&lang=js&"
export * from "./SalesCountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports